/* AFO Wishlist â€” guest wishlist stored in localStorage.
   Upload as assets/afo-wishlist.js. Used by the PDP button block and the wishlist page block. */
(function () {
  const KEY = 'afo_wishlist';
  const MAX = 60;

  function read() {
    try {
      const v = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(v) ? v.filter(h => typeof h === 'string') : [];
    } catch (e) { return []; }
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX))); } catch (e) {}
    document.dispatchEvent(new CustomEvent('afo:wishlist', { detail: { handles: list } }));
  }

  window.AFOWishlist = {
    all: read,
    has: h => read().includes(h),
    add(h) { const l = read(); if (!l.includes(h)) { l.unshift(h); write(l); } return true; },
    remove(h) { write(read().filter(x => x !== h)); return false; },
    toggle(h) { return this.has(h) ? this.remove(h) : this.add(h); },
    clear() { write([]); },
    count: () => read().length
  };

  // Keep tabs in sync
  window.addEventListener('storage', e => {
    if (e.key === KEY) document.dispatchEvent(new CustomEvent('afo:wishlist', { detail: { handles: read() } }));
  });
})();